module.exports = __webpack_public_path__ + "static/media/salas_de_juntas.02da4f2f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/salas_de_juntas.jpeg
// module id = 510
// module chunks = 1